// extracted by mini-css-extract-plugin
export default {"forgotpin-container":"ForgotPinScreen_forgotpin-container__9EDVG","forgotpin-text":"ForgotPinScreen_forgotpin-text__og4+n"};